import * as React from 'react';
import { FAQCommon } from './FAQCommon';

export default function FAQ() {
  return <FAQCommon />;
}
